module.exports = __webpack_public_path__ + "img/swipe-left.6c43c6d2.gif";